// Revised on 2024/12/13 by mnavarro
import Cookies from 'js-cookie';
import { stopCrataWidget, updateCrataWidgetSession } from '@/plugins/CrataWidget';

const axios = require('axios').default;
const globalVars = require('../globalVars');

function createAxios() {
  const instance = axios.create({
    baseURL: globalVars.apiServer,
  });

  instance.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.accessToken) {
      config.headers['Authorization'] = `Bearer ${user.accessToken}`;
    }
    config.headers['X-Language'] = Cookies.get('Picko.language') || 'en'; // TODO: se debe deshacer el uso de la cookie
    config.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return config;
  });

  instance.interceptors.response.use((response) => {
    const newAccessToken = response.headers && response.headers['picko-v2-access-token'];
    if (newAccessToken) {
      const storedUser = JSON.parse(localStorage.getItem('user'));
      if (storedUser) {
        storedUser.accessToken = newAccessToken;
        localStorage.setItem('user', JSON.stringify(storedUser));
        updateCrataWidgetSession(newAccessToken);
      }
    }
    return Promise.resolve(response);
  }, (error) => {
    if (error.response) {
      if ([401].includes(error.response.status)) {
        location.replace('/Error/401');
        //localStorage.removeItem('user');
        // eslint-disable-next-line no-restricted-globals
        //location.reload(true);
      } else if([403].includes(error.response.status)) {
        location.replace('/Error/403');
      } else if([424].includes(error.response.status)) {
        stopCrataWidget();
        localStorage.removeItem('user');
        // eslint-disable-next-line no-restricted-globals
        location.reload(true);
      }
      return Promise.reject(error.response.data);
    } else {
      return Promise.reject("Error accessing API services");
    }
  });
  return instance;
}

export default createAxios;
export { createAxios };